import {usePageContext}                       from '@/context/PageContext'
import useFloatingMenuColor                   from '@/utils/useFloatingMenuColor'
import cn                                     from 'classnames'
import Link                                   from 'next/link'
import {useEffect, useMemo, useRef, useState} from 'react'
import styles                                 from './FloatingMenu.module.sass'

const FloatingMenu = ({floatingMenu}) => {
	const [isMenuActive, setIsMenuActive] = useState(true)
	const timeoutRef                      = useRef(null)
	const {pathnameWithoutLocale}         = usePageContext()
	const menuItems                       = useMemo(() => floatingMenu.items.filter(fm => fm.link !== pathnameWithoutLocale), [floatingMenu.items, pathnameWithoutLocale])
	const lastScrollTop                   = useRef(0)

	const handleMenuActive = () => {
		const scrollTop = Math.max(0, window.scrollY || document.documentElement.scrollTop)

		timeoutRef.current && clearTimeout(timeoutRef.current)
		const isScrollingDown = scrollTop > lastScrollTop.current

		// Scroll down
		if (isScrollingDown) {
			setIsMenuActive(false)
			timeoutRef.current = setTimeout(() => setIsMenuActive(true), 500)
		} else {
			setIsMenuActive(true)
		}

		lastScrollTop.current = scrollTop
	}

	useEffect(() => {
		const abortController = new AbortController()

		window.addEventListener('scroll', handleMenuActive, {signal: abortController.signal})

		return () => abortController.abort()
	}, [])

	const {isFloatingMenuLight} = useFloatingMenuColor()

	return (<div
		className={cn(styles['floating-menu'], {[styles['floating-menu--active']]: isMenuActive}, {[styles['floating-menu--light']]: isFloatingMenuLight}, 'js-floating-button')}
	>
		<div className={styles['floating-menu__items']}>
			{menuItems.map((menuItem, index) => (<FloatingMenuItem
				menuItem={menuItem}
				key={index}
			/>))}
		</div>
	</div>)
}
export default FloatingMenu

const FloatingMenuItem = ({
	menuItem,
	...props
}) => {
	const {lang} = usePageContext()

	return (<Link
		className={styles['floating-menu-item']}
		href={`/${lang}${menuItem.link}`} {...props}
		data-cursor-pointer
	>
		{/*Duplicates names to simulate the font-weight change with opacity transition*/}
		<div className={styles['floating-menu-item__name']}>{menuItem.label}</div>
		<div className={styles['floating-menu-item__name--absolute']}>{menuItem.label}</div>
	</Link>)
}
